var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrophyicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "trophy_24dp_5F6368_FILL1_wght400_GRAD0_opsz24 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.25 36.75V33.25H19.25V27.825C17.8208 27.5042 16.5448 26.899 15.4219 26.0094C14.299 25.1198 13.475 24.0042 12.95 22.6625C10.7625 22.4 8.93229 21.4448 7.45937 19.7969C5.98646 18.149 5.25 16.2167 5.25 14V12.25C5.25 11.2875 5.59271 10.4635 6.27812 9.77812C6.96354 9.09271 7.7875 8.75 8.75 8.75H12.25V5.25H29.75V8.75H33.25C34.2125 8.75 35.0365 9.09271 35.7219 9.77812C36.4073 10.4635 36.75 11.2875 36.75 12.25V14C36.75 16.2167 36.0135 18.149 34.5406 19.7969C33.0677 21.4448 31.2375 22.4 29.05 22.6625C28.525 24.0042 27.701 25.1198 26.5781 26.0094C25.4552 26.899 24.1792 27.5042 22.75 27.825V33.25H29.75V36.75H12.25ZM12.25 18.9V12.25H8.75V14C8.75 15.1083 9.07083 16.1073 9.7125 16.9969C10.3542 17.8865 11.2 18.5208 12.25 18.9ZM29.75 18.9C30.8 18.5208 31.6458 17.8865 32.2875 16.9969C32.9292 16.1073 33.25 15.1083 33.25 14V12.25H29.75V18.9Z",
    fill: "#D9E8F2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrophyicon);
export default __webpack_public_path__ + "static/media/trophy+icon.6ed5d7e4fbd0b8f677053c0bd0f5f37e.svg";
export { ForwardRef as ReactComponent };